import PasswordFormModal from './PasswordFormModal';

export default PasswordFormModal;


// WEBPACK FOOTER //
// ./src/components/PasswordFormModal/index.jsx